import { Controller } from 'stimulus';

class Console extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    import(/* webpackChunkName: "console" */ '../console')
      .then((module) => {
        module.default(this.element);
      });
  }
}

export default Console;
